import styled from 'styled-components';

export const DeleteTypeModalSC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .title {
    margin-bottom: 31px;
    font-style: normal;
    font-weight: 300;
    font-size: 24px;
    line-height: 32px;

    /* identical to box height, or 133% */

    text-align: center;
    color: #171d42;
  }

  .sub-title {
    margin-bottom: 35px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;

    /* or 143% */

    text-align: center;
    color: #464b5d;
  }

  .event-info {
    padding: 16px 29px;
    margin-bottom: 17px;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 20px;

    /* identical to box height, or 100% */

    color: #464b5d;
    background: rgba(255, 51, 92, 0.1);
    border-radius: 16px;

    .time {
      margin-left: 16px;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 20px;

      /* identical to box height, or 100% */

      color: #ff335c;
    }
  }

  .actions-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    button:not(:last-child) {
      margin-right: 16px;
    }
  }

  .single-delete-button {
    margin: 0 auto;
    width: 50%;
  }
`;
